import { Model, modelRegistry } from './Model';
export class ProductCategory extends Model {
    static entity = 'product_categories';
    id = null;
    name = '';
    type = null;
    created_at = null;
    updated_at = null;
    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(''),
            type: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
}
export default ProductCategory;
modelRegistry.register('ProductCategory', ProductCategory);
//# sourceMappingURL=ProductCategory.js.map